import { Col, Row } from 'antd';
import i18n from 'i18next';
import { ReactComponent as EmptyRecordsIcon } from '../../../assets/icons/empty-records.svg';
import { uniqueID } from '../../../utilz';
import SvgConverter from './SvgConverter';

const EmptyRecords = ({
  descriptionTwo = i18n.t('translation:default.emptyRecords.title'),
  title = i18n.t('translation:default.emptyRecords.title'),
  descriptionOne = i18n.t('translation:default.emptyRecords.descriptionOne'),
  className = '',
  padding = 'p-50',
}) => {
  return (
    <Row
      className={`h-100 background-white br-5 box-shadow ${className} ${padding}`}
      align="middle"
      justify="center"
      id={uniqueID()}
    >
      <Col id={uniqueID()}>
        <Row id={uniqueID()} className="flex-direction-column" align="middle" justify="center">
          <Col id={uniqueID()} className="pb-30">
            <SvgConverter Icon={EmptyRecordsIcon} color={false} className="vh-25" />
          </Col>
          <Col id={uniqueID()} justify="center ">
            {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
            <label
              id={uniqueID()}
              data-testid="empty-records-title"
              className="empty-records-title text-center text-danger-1 f-20 fw-700"
            >
              {title}
            </label>
          </Col>
          <Col id={uniqueID()} justify="center">
            <Row id={uniqueID()} className="flex-direction-column pt-5 " align="middle" justify="center">
              <Col id={uniqueID()} className="empty-records-description text-center text-dark f-14 fw-400">
                {descriptionOne} <br />
              </Col>
              <Col id={uniqueID()} className="empty-records-description text-center text-dark f-14 fw-400">
                {descriptionTwo}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default EmptyRecords;
